import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
//import {GoogleAnalytics} from '@awesome-cordova-plugins/google-analytics/ngx';
import { ModalController, NavController, Platform} from '@ionic/angular';
import {from, timer} from 'rxjs';
import {switchMap, take, tap} from 'rxjs/operators';
import {AdsConfig} from '../../config/ads.config';
import {Comment} from '../../core/api/resources/comment.resource';
import {RoadtripDetail} from '../../core/api/resources/roadtrip-detail.resource';
import {Step} from '../../core/api/resources/step.resource';
import {ModalActionEnum} from '../../core/enum/modal-action.enum';
import {UnrAdsService} from '../../services/ads.service';
import {UnrFeedbackService} from '../../services/feedback.service';
import {MapsHelperService} from '../../services/maps-helper/maps-helper.service';
import {UnrAdsComponent} from '../../shared/ads/ads.component';
import {UnrGoogleMapComponent} from '../../shared/maps/components/google-map/google-map.component';
import {UnrMapKitMapComponent} from '../../shared/maps/components/mapkit-map/mapkit-map.component';
import {StepStateService} from './step.state-service';
import {UnrImageViewer} from '../../shared/image-viewer/image-viewer.component';

@Component({
  selector: 'page-step-details',
  templateUrl: 'step-details.html',
  styleUrls: [
    'step-details.scss'
  ]
})
export class StepDetailsPage implements OnInit {
@ViewChild('slider', { static: false }) slider: any;
  
showSlider = true;
  hasCommentedForTrip = false;
  enableDownloadGPXButton = false;
  trip: RoadtripDetail;
  step: Step;
  steps: Step[];
  comments: Comment[];
  initialSlide = 0;
  averageRating = 0;
  sliderOptions = {
    initialSlide: 0,
    centeredSlides: false
  };

  constructor(private stepStateService: StepStateService,
              private router: Router,
              private navController: NavController,
              private feedbackService: UnrFeedbackService,
              private adsService: UnrAdsService,
              private modalCtrl: ModalController,
              private platform: Platform,
             // private googleAnalytics: GoogleAnalytics
            ) {
  }

  ngOnInit(): void {
    this.getNavParams();
    this.getInitialSlide();
    this.getComments();
    //this.googleAnalytics.trackView(`Roadtrip details: ${this.step.stepName}`);

    if (this.adsService.isFirstStep(this.step, this.steps)) {
     // this.showAd();
      this.enableDownloadGPXButton = true;
    }

    this.slideToFirstImage();
  }

  async viewMap(): Promise<void> {
    const mapType = this.platform.is('ios')
      ? UnrMapKitMapComponent
      : UnrGoogleMapComponent;

    const mapModal: HTMLIonModalElement = await this.modalCtrl.create({
      component: mapType,
      componentProps: {
        [MapsHelperService.NAV_PARAM_GPX]: this.trip.gpxFile,
        [MapsHelperService.NAV_PARAM_STEP]: this.step
      },
      showBackdrop: true,
      backdropDismiss: true,
      cssClass: 'modal--popup2'
    });
    mapModal.present();
  }

  async showAd(): Promise<void> {
    if (this.adsService.ads.length > 0) {
      const modal = await this.modalCtrl.create({
        component: UnrAdsComponent,
        cssClass: 'modal--popup'
      });

    //  this.googleAnalytics.trackView(`Ad: ${this.adsService.ads[0].advertiserName}`);

      from(modal.present())
        .pipe(
          switchMap(() => timer(1, 1000)),
          take(AdsConfig.durationInSeconds)
        )
        .subscribe(
          undefined,
          undefined,
          () => modal.dismiss()
        );
    }
  }

  async showAddCommentModal(): Promise<void> {
    if (this.feedbackService.hasUserAlreadyProvidedFeedback(this.comments)) {
      await this.feedbackService.showToastFeedbackProvided();
      return;
    }

    const modal: HTMLIonModalElement = await this.feedbackService.showAddCommentAndRatingModalForStep(this.hasCommentedForTrip);
    const {data, role} = await modal.onDidDismiss();
    if (role === ModalActionEnum.Save
      || role === ModalActionEnum.SaveForRequestAddTripComment
      || role === ModalActionEnum.CancelForRequestAddTripComment) {
      (await this.feedbackService
        .postFeedbackForStep(
          this.step,
          data
        ))
        .pipe(
          tap(comments => {
            this.comments = comments;
            this.averageRating = this.feedbackService.getAverageRating(comments);
          })
        )
        .subscribe();
    }

    if (role === ModalActionEnum.SaveForRequestAddTripComment) {
      await this.rateOrCommentTrip();
    }
  }

  async rateOrCommentTrip(): Promise<void> {
    const modal = await this.feedbackService.showAddCommentAndRatingModalForTrip();
    const {data, role} = await modal.onDidDismiss();

    if (role === ModalActionEnum.Save) {
      (await this.feedbackService
        .postFeedbackForTrip(
          this.trip,
          data
        )).subscribe();
    }
  }

  onStepTap(step: Step): void {
    if (step.id !== this.step.id) {
      this.showSlider = false; // 👈 destroy swiper

      this.stepStateService.step = step;
      this.stepStateService.trip = this.trip;
      this.stepStateService.hasCommentedTrip = this.hasCommentedForTrip;
      this.ngOnInit();
        setTimeout(() => {
      this.showSlider = true; // 👈 recreate swiper at slide 0
    });
    }
  }

  private resetImageSlider(): void {
  if (this.slider?.swiper) {
    this.slider.swiper.slideTo(0, 0); // 👈 always start from 0
  }
}


  async onSelectImage(url: string): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: UnrImageViewer,
      componentProps: {
        imageUrl: url
      },
      backdropDismiss: true,
      showBackdrop: true,
      cssClass: 'modal--popup'
    });
    await modal.present();
  }

  private slideToFirstImage(): void {
    // if (this.slider) {
    //   this.slider.slideTo(0).then();
    // }
  }

  private getComments(): void {
    this.feedbackService
      .getFeedbackForStep(this.step.id)
      .subscribe(comments => {
        this.comments = comments;
        this.averageRating = this.feedbackService.getAverageRating(comments);
      });
  }

  private getNavParams(): void {
    this.trip = this.stepStateService.trip;
    if (!this.trip) {
      this.router.navigate(['/']);
    } else {
      this.step = this.stepStateService.step;
      this.steps = this.stepStateService.trip.steps;
      this.hasCommentedForTrip = this.stepStateService.hasCommentedTrip;
    }
  }

  private getInitialSlide(): void {
    if (this.steps) {
      this.initialSlide = this.steps.findIndex(stepInList => stepInList.id === this.step.id);
    }
  }
  
}
